import type { HostedAuthPlugin } from '@unipile/ui';
import { linkedinProductIcons } from '../products';
import { Wizard } from './components/Wizard';

export const linkedinHaPlugin: HostedAuthPlugin = {
  Component: Wizard,
  productIcons: linkedinProductIcons,
  registerTrads({ locales, i18n }) {
    return Promise.all(
      locales.map(async (locale) => {
        const data: { default: object } = await import(`./translations/${locale}.json`);
        i18n.addResourceBundle(locale, 'linkedin', data.default);
      }),
    );
  },
};
